/**
 * Match title separator — keep in sync with watchout/seo/event_title.py
 * EVENT_MATCH_SEPARATOR (change there to ' vs ' site-wide when needed).
 */
export const EVENT_MATCH_SEPARATOR = ' - '

const MATCH_SEPARATOR_RE = /\s+(?:kontra|vs\.?|v\.?)\s+|\s*[–—−]\s*|\s+-\s+/i

export function formatMatchTitle (
  home: string | null | undefined,
  away: string | null | undefined,
  separator: string = EVENT_MATCH_SEPARATOR
): string {
  const left = (home || '').trim()
  const right = (away || '').trim()
  if (!left || !right) {
    return left || right
  }
  return `${left}${separator}${right}`
}

export function normalizeMatchTitle (
  title: string | null | undefined,
  separator: string = EVENT_MATCH_SEPARATOR
): string {
  if (!title) {
    return ''
  }
  const normalized = String(title).replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim()
  const match = MATCH_SEPARATOR_RE.exec(normalized)
  if (!match) {
    return normalized
  }
  const home = normalized.slice(0, match.index).trim()
  const away = normalized.slice(match.index + match[0].length).trim()
  if (!home || !away) {
    return normalized
  }
  return formatMatchTitle(home, away, separator)
}
